import { chipClasses as MuiChipClasses, getChipUtilityClass, ChipClasses } from '@mui/material';

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    subtle: true;
  }

  interface ChipPropsColorOverrides {
    default: false;
    turquoiseDark: true;
    flamingo: true;
    turquoise: true;
    yellow: true;
    neutral: true;
    success: true;
  }

  interface ChipClasses {
    subtle: string;
    subtlePrimary: string;
    subtleSecondary: string;

    colorTurquoise: string;
    colorTurquoiseDark: string;
    colorFlamingo: string;
    colorYellow: string;
    colorNeutral: string;
  }
}

export const chipClasses: ChipClasses = {
  ...MuiChipClasses,
  subtle: getChipUtilityClass('subtle'),
  subtlePrimary: getChipUtilityClass('subtlePrimary'),
  subtleSecondary: getChipUtilityClass('subtleSecondary'),
  colorTurquoiseDark: getChipUtilityClass('colorTurquoiseDark'),
  colorFlamingo: getChipUtilityClass('colorFlamingo'),
  colorTurquoise: getChipUtilityClass('colorTurquoise'),
  colorYellow: getChipUtilityClass('colorYellow'),
  colorNeutral: getChipUtilityClass('colorNeutral'),
};
